const CLIENT_CODE_PATTERN = /^[a-z0-9-]+$/;
const MIN_LENGTH = 1;
const MAX_LENGTH = 30;
/**
 * Validates a Client_Code string.
 * Accepts if and only if: 1-30 characters, lowercase alphanumeric and hyphens only.
 */
export function validateClientCode(code) {
    const errors = [];
    if (code.length < MIN_LENGTH) {
        errors.push('Client code must be at least 1 character');
    }
    if (code.length > MAX_LENGTH) {
        errors.push('Client code must not exceed 30 characters');
    }
    if (code.length >= MIN_LENGTH && !CLIENT_CODE_PATTERN.test(code)) {
        errors.push('Client code must contain only lowercase alphanumeric characters and hyphens');
    }
    return { valid: errors.length === 0, errors };
}
//# sourceMappingURL=client-code.js.map